<template>
  <v-dialog v-model="dialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase">
        Thêm phân công chủ nhiệm
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-5" style="margin-bottom: 100px">
        <OwnClassTeacherNewForm ref="form" :defaultTeacher="defaultTeacher" :state="dialog" />
      </v-card-text>

      <v-divider />

      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn outlined @click="cancel" :disabled="loading">HUỶ</v-btn>
        <v-btn color="primary" @click="save" :loading="loading" :disabled="loading">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OwnClassTeacherNewForm from '@/components/basic/form/OwnClassTeacherNewForm'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { get, isArray, uniq } from 'lodash'

export default {
  name: 'OwnClassTeacherNewDialogMany',
  components: {
    OwnClassTeacherNewForm
  },
  props: {
    state: Boolean,
    teacher: Object,
    defaultTeacher: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialog: false,
      loading: false
    }
  },
  computed: {
    ...mapState('app', ['currentSchoolYear'])
  },
  methods: {
    ...mapActions('ownClassTeacher', ['updateClass']),
    async save() {
      try {
        const data = this.$refs.form.getData()
        if (!data) return

        let selectedTeachers = []

        if (data.teachers && isArray(data.teachers)) {
          selectedTeachers = data.teachers
        } else if (data.teacher) {
          selectedTeachers = [data.teacher]
        }

        if ((!selectedTeachers || selectedTeachers.length === 0) && this.defaultTeacher && this.defaultTeacher.id) {
          selectedTeachers = [this.defaultTeacher]
        }

        if (!selectedTeachers || selectedTeachers.length === 0) {
          this.$alert && this.$alert.error
            ? this.$alert.error('Vui lòng chọn giáo viên để phân công')
            : console.warn('No teacher selected')
          return
        }

        this.loading = true
        const { classData } = data
        if (!classData || !classData.id) {
          this.$alert && this.$alert.error
            ? this.$alert.error('Dữ liệu lớp không hợp lệ')
            : console.warn('Invalid classData')
          return
        }

        let headTeachersExisting = []
        if (get(classData, 'headTeachers')) {
          const ht = classData.headTeachers
          if (isArray(ht) && ht.length && typeof ht[0] === 'object') {
            headTeachersExisting = ht.map(x => x.id).filter(Boolean)
          } else if (isArray(ht)) {
            headTeachersExisting = ht.filter(Boolean)
          }
        }

        const newTeacherIds = selectedTeachers.map(t => get(t, 'id')).filter(Boolean)

        const combined = [
          ...newTeacherIds,
          ...headTeachersExisting.filter(id => !newTeacherIds.includes(id))
        ]

        const finalHeadTeacherIds = uniq(combined)

        const metadata = {
          ...(classData.metadata || {})
        }
        const yearId = get(this.currentSchoolYear, 'id')
        const now = moment().toISOString()
        if (yearId) {
          newTeacherIds.forEach(tid => {
            if (tid) {
              metadata[`${tid}-${yearId}`] = now
            }
          })
        }

        const payload = {
          id: classData.id,
          headTeachers: finalHeadTeacherIds,
          metadata
        }

        const c = await this.updateClass(payload)

        this.$alert && this.$alert.success
          ? this.$alert.success('Cập nhật thành công')
          : console.log('Update success')

        this.dialog = false
        this.$emit('done', c)
      } catch (error) {
        console.error(error)
        this.$alert && this.$alert.updateError
          ? this.$alert.updateError(error)
          : console.error('Update error', error)
      } finally {
        this.loading = false
      }
    },

    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      if (state) {
        this.dialog = true
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.reset && this.$refs.form.reset()
        })
      } else {
        this.dialog = false
      }
    }
  }
}
</script>
